import { createTheme } from "@mui/material/styles";

// Light theme using the firm's sage green
const theme = createTheme({
  palette: {
    primary: {
      main: "#C3D178",
      contrastText: "#141414",
    },
    secondary: {
      main: "#141414",
      contrastText: "#fff",
    },
    text: {
      primary: "#141414",
    },
  },
  typography: {
    fontFamily: "Aptos, \"Segoe UI\", Arial, sans-serif",
  },
});

export default theme;
